import React, { useState } from "react";
import { commitMutation, graphql, useLazyLoadQuery } from "react-relay";
import "./DraftKingsInfoOverlaySlateList.css";
import relayEnvironment from "../../../RelayEnvironment";
import { COMMIT_PLAYER_CHANGES } from "../../__pages/__tools/GreenMachinePage/SelectPlayers/mutations/CommitPlayerSelectionChanges";
import FlexBreak from "../../FlexBreak";
import PGARecentHistory from "../PGARecentHistory";
import Tabs from "../../Tabs";

const GET_SLATE_PLAYERS = graphql`
  query DraftKingsOverlaySlateListQuery($playerId: ID!) {
    playerInfo(playerId: $playerId) {
      sport {
        name
      }

      playerDkId
      headshotUrl
    }

    activeSlatePlayersForDkPlayer(playerId: $playerId) {
      slatePlayer {
        id
        player {
          name
        }

        salary

        slateCompetition {
          slate {
            suffix
            prettyStartTime

            gameType {
              name
              sport {
                name
              }
            }
          }
        }
      }

      selected
    }
  }
`;

export default function DraftkingsOverlaySlateList(props) {
  const data = useLazyLoadQuery(
    GET_SLATE_PLAYERS,
    {
      playerId: props.playerId,
    },
    { fetchPolicy: "network-only", fetchKey: props.fetchNum }
  );

  const [playerSelectUpdates, setPlayerSelectUpdates] = useState({});
  const [imageErrored, setImageErrored] = useState(false);

  function isPlayerCurrentlySelected(slatePlayerID) {
    if (slatePlayerID in playerSelectUpdates) {
      return playerSelectUpdates[slatePlayerID];
    } else {
      return undefined;
    }
  }

  function togglePlayerForSlate(slatePlayerID, selected) {
    let addPlayers = [];
    let removePlayers = [];

    if (selected) {
      addPlayers.push(slatePlayerID);
    } else {
      removePlayers.push(slatePlayerID);
    }

    commitMutation(relayEnvironment, {
      mutation: COMMIT_PLAYER_CHANGES,
      variables: {
        input: {
          addPlayers: addPlayers,
          removePlayers: removePlayers,
        },
      },
      onCompleted: (content, errors) => {
        if (!errors) {
          setPlayerSelectUpdates((prev) => {
            const prevEditable = { ...prev };

            prevEditable[slatePlayerID] = selected;

            return prevEditable;
          });
        } else {
          alert("Something went wrong.");
        }
      },
      onError: (error) => {
        alert("Something went wrong.");
      },
    });
  }

  const player = data.activeSlatePlayersForDkPlayer[0]?.slatePlayer.player;

  if (!player) {
    return (
      <div>
        <p>No active slates for player.</p>
      </div>
    );
  }

  const sportName = data.playerInfo?.sport.name;

  const headshotUrl = data.playerInfo.headshotUrl;

  return (
    <div className="dk-info-overlay-slate-list-container">
      {headshotUrl ? (
        <img
          className="dk-info-overlay-headshot-image"
          src={headshotUrl}
          alt={"Headshot for " + player.name}
          onError={() => {
            setImageErrored(true);
          }}
        />
      ) : null}
      <FlexBreak />
      <h2 style={{ textAlign: "center" }}>{player.name}</h2>
      <FlexBreak />

      <div className="dk-info-overlay-tabs-container">
        <Tabs>
          {sportName === "GOLF" ? (
            <div
              className="dk-info-overlay-slate-list-section"
              label="Recent Rounds"
            >
              <PGARecentHistory playerId={props.playerId} />
            </div>
          ) : null}

          <div
            className="dk-info-overlay-slate-list-section"
            label="Add To Green Machine"
          >
            {data.activeSlatePlayersForDkPlayer.map((quickAddObj) => {
              const slatePlayer = quickAddObj.slatePlayer;

              const slate = slatePlayer.slateCompetition.slate;

              let selected = isPlayerCurrentlySelected(slatePlayer.id);

              if (selected === undefined) {
                selected = quickAddObj.selected;
              }

              return (
                <div
                  key={slatePlayer.id}
                  className={`dk-info-overlay-slate-list-option dk-info-overlay-slate-list-option-${
                    selected ? "" : "un"
                  }selected`}
                  role="button"
                  onClick={() => {
                    togglePlayerForSlate(slatePlayer.id, !selected);
                  }}
                  onKeyPress={() => {
                    togglePlayerForSlate(slatePlayer.id, !selected);
                  }}
                  tabIndex={0}
                >
                  {slate.gameType.sport.name} {slate.gameType.name}{" "}
                  {slate.prettyStartTime} {slate.suffix} - ${slatePlayer.salary}
                </div>
              );
            })}
          </div>
        </Tabs>
      </div>
    </div>
  );
}
